module.exports = __webpack_public_path__ + "img/suzukilogo.419e380a.png";